/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/cert/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";

interface Props {
  certData?: Data[];
}

interface RowData {
  id: string;
  description?: string;
  commonName?: string;
  caSerialNumber?: string;
  serialNumber?: string;
  x509?: string;
}

const mapDataToTable = (cert: Data[]): RowData[] => {
  return cert.map((data) => {
    return {
      id: data.id,
      description: data.attributes.Description,
      commonName: data.attributes.CommonName,
      caSerialNumber: data.attributes.CASerialNumber,
      serialNumber: data.attributes.SerialNumber,
      x509: data.attributes.X509,
    };
  });
};

export default function CertTable({ certData }: Props) {
  const history = useHistory();

  const data = mapDataToTable(certData);

  const editAction = (rowData: RowData) => {
    history.push(`/cert/edit/${rowData.id}`);
  };

  const viewAction = (rowData: RowData) => {
    history.push(`/cert/view/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Description",
        accessorKey: "description",
      },
      { header: "CA Serial No", accessorKey: "caSerialNumber" },
      { header: "Serial No", accessorKey: "serialNumber" },
      { header: "Common Name", accessorKey: "commonName" },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="Cert"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
